
import {get,post} from "@/axios";


export function sourceVisitor(data) {
    return post('/api/sourceVisitor/index',data);
}

